import { createFileRoute } from '@tanstack/react-router'
import { WissenIndexPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/sapere/')({
  loader: () => loadPageData({ data: { kind: 'knowledge', locale: 'it' } }),
  head: () => staticRouteHead('knowledge', 'it'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <WissenIndexPage />
    </CatalogProvider>
  )
}
